import { createFileRoute } from "@tanstack/react-router";
import StudentRegistrationsPerMonthReport from "@/pages/reports/print/student-registrations-per-month";

export const Route = createFileRoute(
  "/_authenticated/reports/detailed-view/monthly-student-registrations/$date",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <StudentRegistrationsPerMonthReport />;
}
